import React from 'react'
import Slider from "./Slider"
import CategoryMonth from "./CategoryMonth";
import Featured from "./Featured"
import {SliderData, CategoryMonthData , FeaturedData} from "./HomeData";

function Home() {
    return (
        <>
         <Slider val={SliderData} />
         <CategoryMonth value={CategoryMonthData} /> 
         <Featured  data={FeaturedData} />  
        </>
    )
}

export default Home;
